import { createAction, props } from "@ngrx/store";

export const FETCH_STAFF_LIST = createAction(
    'FETCHSTAFFLIST',
    props<{ staffList: any }>()
);

export const FETCH_STAFF_LIST_ALL = createAction(
    'FETCHSTAFFLISTALL',
    props<{ staffListAll: any }>()
);

export const FETCHEDSTAFFDETAILS = createAction(
    'FETCHEDSTAFFDETAILS',
    props<{ staffDetails: any }>()
);

export const ERRORSTAFFLIST = createAction(
    'ERROR_STAFF_LIST',
    props<{ error: any }>()
);

export const FETCH_STAFF_NOTIFICATIONS = createAction(
    'FETCH_STAFF_NOTIFICATIONS',
    props<{ staffNotifications: any, companyId:any }>()
);

export const STAFF_NOTIFICARIONS_SUCCESS  = createAction(
    'STAFF_NOTIFICARIONS_SUCCESS',
    props<{staffNotifications:any}>()
  );